import {Component, OnDestroy} from '@angular/core';
import {ModalKendo} from '../lib/ModalKendo';
import {ContatosService} from '../services/contatos.service';

@Component({
  selector: 'app-modal-mesclar-contatos',
  templateUrl: './modal-mesclar-contatos.component.html',
  styleUrls: ['./modal-mesclar-contatos.component.scss']
})
export class ModalMesclarContatosComponent extends ModalKendo implements OnDestroy {
  principal: any = null;
  origem: any = null;
  candidatos: any[] = [];
  previa: any = null;
  buscando = false;
  carregandoPrevia = false;
  mesclando = false;
  erroBusca = '';
  erroPrevia = '';
  erroMesclagem = '';
  private buscaAtual = 0;
  private selecaoAtual = 0;
  private aberto = true;

  constructor(private contatosService: ContatosService) {
    super();
  }

  inicie(principal: any) {
    this.principal = principal;
    this.busqueCandidatos('');
  }

  async busqueCandidatos(termo: string) {
    const busca = ++this.buscaAtual;
    this.buscando = true;
    this.erroBusca = '';
    try {
      const candidatos = await this.contatosService.busqueCandidatosMesclagem(this.principal.id, termo);
      if (!this.aberto || busca !== this.buscaAtual) return;
      this.candidatos = (candidatos || []).filter((contato: any) => Number(contato.id) !== Number(this.principal.id));
    } catch (erro) {
      if (this.aberto && busca === this.buscaAtual)
        this.erroBusca = 'Não foi possível buscar contatos. Tente novamente.';
    } finally {
      if (this.aberto && busca === this.buscaAtual) this.buscando = false;
    }
  }

  selecioneOrigem(origem: any) {
    if (this.mesclando) return;
    this.origem = origem?.id && Number(origem.id) !== Number(this.principal?.id) ? origem : null;
    this.previa = null;
    this.erroPrevia = this.erroMesclagem = '';
    ++this.selecaoAtual;
    this.carregandoPrevia = false;
    if (this.origem) this.carreguePrevia();
  }

  async carreguePrevia() {
    if (!this.origem || this.mesclando) return;
    const selecao = ++this.selecaoAtual;
    const origemId = this.origem.id;
    this.previa = null;
    this.erroPrevia = this.erroMesclagem = '';
    this.carregandoPrevia = true;
    try {
      const previa = await this.contatosService.obtenhaPreviaMesclagem(this.principal.id, origemId);
      if (this.aberto && selecao === this.selecaoAtual && this.origem?.id === origemId)
        this.previa = previa;
    } catch (erro) {
      if (this.aberto && selecao === this.selecaoAtual)
        this.erroPrevia = typeof erro === 'string' && erro.trim()
          ? erro : 'Não foi possível carregar a prévia. Tente novamente.';
    } finally {
      if (this.aberto && selecao === this.selecaoAtual) this.carregandoPrevia = false;
    }
  }

  podeMesclar(): boolean {
    return !!(this.aberto && !this.mesclando && !this.carregandoPrevia && this.principal?.id && this.origem?.id
      && this.previa?.versao && !(this.previa.bloqueios || []).length);
  }

  async mescle() {
    if (!this.podeMesclar()) return;
    const selecao = this.selecaoAtual;
    const origemId = this.origem.id;
    const versao = this.previa.versao;
    this.mesclando = true;
    this.erroMesclagem = '';
    try {
      const resultado = await this.contatosService.mescleContatos(this.principal.id, origemId, versao);
      if (this.aberto && selecao === this.selecaoAtual) this.window.close({id: resultado.id});
    } catch (erro) {
      if (this.aberto && selecao === this.selecaoAtual) {
        this.mesclando = false;
        const revisaoPrevia = this.selecaoAtual + 1;
        await this.carreguePrevia();
        if (this.aberto && this.selecaoAtual === revisaoPrevia && this.origem?.id === origemId)
          this.erroMesclagem = 'A mesclagem não foi concluída. Confira a prévia atualizada antes de tentar novamente.';
      }
    } finally {
      if (this.aberto && selecao === this.selecaoAtual) this.mesclando = false;
    }
  }

  pontosNoContato(contato: any, planoId: number): number {
    return (contato?.pontos || []).find((plano: any) => plano.planoId === planoId)?.pontos || 0;
  }

  feche() {
    if (this.mesclando) return;
    this.aberto = false;
    ++this.buscaAtual;
    ++this.selecaoAtual;
    this.window.close();
  }

  ngOnDestroy() {
    this.aberto = false;
    ++this.buscaAtual;
    ++this.selecaoAtual;
  }
}
